<template>
  <div class="items-center justify-center flex mt-10">
     <img src="/img/party.png" class="w-[372px]" />
  </div>
</template>

<script>
export default {
};
</script>

<style></style>
